<template>
  <div :style="{ height: `${height}px` }">
    <svg class="tag-box" xmlns="http://www.w3.org/2000/svg" :width="widthWithArrow" :height="height">
      <path :d="boxPath" fill="none" :stroke="netcallSalmonColour" :stroke-width="border + 1" />
      <path :d="arrowPath" fill="none" :stroke="netcallSalmonColour" :stroke-width="border" />

      <text :x="textX" :y="textBaseline" alignment-baseline="middle" :text-anchor="align">{{ value }}</text>
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    default: 65,
  },
  height: {
    type: Number,
    default: 36,
  },
  border: {
    type: Number,
    default: 1,
  },
  align: {
    type: String as PropType<'left' | 'middle'>,
    default: 'middle',
  },
});

const netcallSalmonColour = '#FF6666';

const boxPath = computed(() => `M${props.width} 0 H0 V${props.height} H${props.width}`);
const arrowPath = computed(
  () => `M${props.width} ${props.height} L${widthWithArrow.value} ${props.height / 2} L${props.width} 0`,
);
const widthWithArrow = computed(() => props.width + 10);
const textBaseline = computed(() => props.height / 2 + props.border * 2);
const textX = computed(() => (props.align === 'left' ? 10 : props.width / 2));
</script>
